import useLoading from 'hooks/useLoading';
import usePromise from 'hooks/usePromise';
import * as UploadModels from 'models/upload';
import UploadResource from 'models/upload/resource';
import React, { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import ContentLoading from 'components/ContentLoading';
import UploadsTable from './Table';
import UploadsContext from './Context';

type Props = {
    accessToken: string
};

export const AllUploads = () => {
  const { accessToken } = useParams<Props>();
  const [loading, setLoading] = useLoading();

  // eslint-disable-next-line max-len
  const request = useCallback(async (signal: AbortSignal) => (await UploadModels.api.ListByToken(accessToken ?? '', signal)).data, [accessToken]);

  const [uploads, setUploads] = usePromise(request, [], setLoading);

  const deleteFile = async (item: UploadResource) => {
    try {
      await UploadModels.api.Delete(item.id);
      setUploads((prev) => prev.filter((u) => u.id !== item.id));
    } catch (error) {
      console.error(error);
      // eslint-disable-next-line no-alert
      alert('Fejl under sletning af fil');
    }
  };

  const contextValue = useMemo(() => ({ deleteUpload: deleteFile }), [deleteFile]);

  return (
    <UploadsContext.Provider value={contextValue}>
      <ContentLoading loading={loading}>
        <UploadsTable values={uploads} />
      </ContentLoading>
    </UploadsContext.Provider>
  );
};

export default AllUploads;
